// extracted by mini-css-extract-plugin
export default {"desktopCont":"desktop-bar_desktopCont__iZD4y"};